module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "news-link",
    attrs: {
      "href": _vm.path
    }
  }, [_c('div', {
    staticClass: "row-2 f-cb"
  }, [_c('h2', {
    staticClass: "title f-toe1"
  }, [_vm._v(_vm._s(_vm.item.listTitle || _vm.item.title))]), _vm._v(" "), (_vm.item.comments != '0' && _vm.item.comments) ? _c('span', {
    staticClass: "comment-count"
  }, [_vm._v(_vm._s(_vm.item.comments))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row-1 f-cb"
  }, [_c('div', {
    staticClass: "col-1",
    style: ({
      height: _vm.imgH
    })
  }, [_c('div', {
    staticClass: "bg-d"
  }, [_c('div', {
    staticClass: "bg-c",
    style: ({
      backgroundImage: 'url(' + _vm.webp(_vm.item.images[0]) + ')'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-2",
    style: ({
      height: _vm.imgH
    })
  }, [_c('div', {
    staticClass: "bg-d"
  }, [_c('div', {
    staticClass: "bg-c",
    style: ({
      backgroundImage: 'url(' + _vm.webp(_vm.item.images[1]) + ')'
    })
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ffb2961a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news_stream/news-img.vue
// module id = 873
// module chunks = 2